const fr = {
  'Language Key': 'fr',
  'cui-org-info': "organisation d'info",
  'cui-sign-on-info': "Inscrivez-vous sur d'info",
  'cui-user-info': 'Informations utilisateur',
  'cui-preferences': 'préférences',
  'cui-review': 'La revue',
  'cui-org': 'Organisation',
  'cui-company-division': 'Division société',
  'cui-org-address': 'organisation Adresse',
  'cui-user-address': "Adresse de l'utilisateur",
  'cui-country': 'Pays',
  'cui-city': 'Ville',
  'cui-state': 'État / Province',
  'cui-postal': 'Code postal',
  'cui-user-id': "Identifiant d'utilisateur",
  'cui-password': 'Mot de passe',
  'cui-password-re': 'Retaper le mot de passe',
  'cui-challenge-question': 'question du défi',
  'cui-challenge-answer': 'réponse Défi',
  'cui-favorite-pet-q': 'Quel est le nom de votre animal de compagnie préféré?',
  'cui-mother-q': 'Quel est le nom de jeune fille de votre mère?',
  'cui-best-friend-q': 'Qui est votre meilleur ami?',
  'cui-first-name': 'Prénom',
  'cui-last-name': 'Nom de famille',
  'cui-email': 'Email',
  'cui-email-re': 'Ressaisissez email',
  'cui-telephone': 'Numéro de téléphone',
  'cui-timezone': 'Fuseau horaire',
  'cui-submit': 'SOUMETTRE',
  'cui-next': "L'ÉTAPE SUIVANTE",
  'cui-previous': 'PRÉCÉDENT',
  'cui-create-security-admin-account': 'Créez votre compte administrateur de la sécurité',
  'cui-skip-for-now': "IGNORER POUR L'INSTANT",
  'icon-library': 'Bibliothèque icône',
  'cui-new-TLO': 'Nouveau Haut Niveau Organisation',
  'cui-new-TLO-description': 'Sélectionnez cette méthode si vous souhaitez rejoindre la Bourse de Covisint en tant que nouvelle organisation Covisint',
  'cui-new-division': 'nouvelle division',
  'cui-new-division-description-start': 'Sélectionnez cette méthode si vous souhaitez devenir',
  'cui-new-division-description-end': "d'une nouvelle division au sein d'une organisation Covisint existante.",
  'cui-security-administrator': 'administrateur de sécurité',
  'cui-new-user': 'Nouvel utilisateur',
  'cui-new-user-description': "Sélectionnez cette méthode si vous êtes un employé d'une recherche Covisint Société Adhérente existante accès à une application de votre organisation souscrit ou si vous n'êtes pas sûr que votre organisation est enregistrée.",
  'cui-sign-up': "S'inscrire",
  'cui-address': 'Adresse',
  'cui-organization-name': 'Division société',
  'cui-supplier-code': 'Code fournisseur',
  'cui-address-1': 'Adresse 1',
  'cui-address-2': 'Adresse 2',
  'cui-user-information': "informations de l'utilisateur",
  'cui-organization-information': "information sur l'organisation",
  'cui-sign-in-information': 'Connexion Informations',
  'cui-package-selection': 'paquet de sélection',
  'cui-welcome-popover': "Les responsabilités de l'administrateur de sécurité seront expliqués en détail après avoir sélectionné une méthode d'enregistrement. Cependant, vous pouvez choisir d'annuler votre inscription afin de permettre à un autre membre de votre Organiziation pour vous inscrire en tant qu'administrateur de sécurité.",
  'create-account': 'Créez votre compte',
  'cui-agree-covisint': "Je suis d'accord sur le Covisint",
  'terms-of-service': "Conditions d'utilisation",
  'cui-and': 'et',
  'privacy-policy': 'Politique de confidentialité',
  'cui-tos-agree': "Vous devez accepter les conditions d'utilisation pour continuer.",
  'cui-user-profile': "Profil de l'utilisateur",
  'cui-my-profile': 'Mon profil',
  'cui-login': "S'identifier",
  'cui-supplier-content': "Mettre à jour cette fois la conception docs entrent en jeu. Ceci est dans le doc google traduction. Lorem Ipsum. D'autres choses. Code du fournisseur d'informations importantes. J'aime les tortues.",
  'cui-all-organizations': 'Toutes les organisations:',
  'cui-application-select-info': 'Vous pouvez toujours faire vos sélections après la connexion pour la première fois.',
  'cui-all-applications': 'toutes les applications',
  'cui-page-not-found': 'Page non trouvée',
  'cui-page-not-found-content': 'La page que vous recherchez pourrait avoir été supprimé, ou jamais existé.',
  'cui-home': 'MAISON',
  'cui-access-denied': 'Accès refusé',
  'cui-access-denied-content': "Vous n'êtes pas autorisé à afficher cette page.",
  'cui-registration-status': "Statut d'enregistrement",
  'cui-pending-status': "Dans l'attente de statut",
  'cui-pending-status-content': "Votre statut d'inscription est toujours en attente. Vous recevrez un e-mail avec plus de détails sous peu.",
  'cui-thank-you': 'Je vous remercie',
  'cui-request-submitted': 'Demande soumise',
  'cui-success': 'Succès',
  'cui-success-content': 'Votre inscription Covisint a été soumis avec succès. Vous recevrez un e-mail avec plus de détails sous peu.',
  'cui-check-your': 'Vérifier votre',
  'cui-registration-status-lower': "Statut d'enregistrement",
  'cui-application-selection': "Sélection d'application",
  'cui-applications': 'Applications',
  'cui-profile-settings': 'Paramètres de profil',
  'cui-name': 'prénom',
  'cui-update': 'Mettre à jour',
  'cui-updated': 'Actualisé',
  'cui-error-try-again': 'Erreur! Réessayer?',
  'cui-back': 'Arrière',
  'cui-selections': 'Sélections',
  'cui-add-org': 'Ajouter une organisation',
  'cui-remove-org': 'Retirer Organisation',
  'cui-select-org': 'Sélectionnez Organisation',
  'cui-more-information': "Plus d'information",
  'cui-inv-user-popover-info': "Pour des raisons de sécurité, vous devez vous inscrire au e-mail votre invitation a été envoyée. Cela peut être modifié dans les paramètres utilisateur lors de l'enregistrement est terminé.",
  'cui-org-profile': "profil de l'organisation",
  'cui-info': 'Info',
  'cui-admins': 'admins',
  'lowercase-not-allowed': 'pas de lettres minuscules',
  'uppercase-not-allowed': 'pas de lettres majuscules',
  'numbers-not-allowed': 'pas de chiffres',
  'special-not-allowed': 'pas de symboles spéciaux (ex: +)',
  'chars-not-allowed': 'ne pas utiliser les caractères suivants : {{disallowedChars}}',
  'words-not-allowed': 'ne pas utiliser les mots suivants : {{disallowedWords}}',
  'password-length': 'avoir entre {{min}}-{{max}} caractères',
  'password-rules': 'avoir {{requiredNumberOfCharClasses}} des éléments suivants',
  'password-lowercase': 'au moins une lettre minuscule',
  'password-uppercase': 'au moins une lettre majuscule',
  'password-number': 'au moins 1 Numéro',
  'password-special': 'au moins 1 symbole spécial (ex: +)',
  'passwords-must': 'Les mots de passe doivent:',
  'welcome-title': 'Inscrivez-vous pour une des options suivantes',
  'cui-application-name': "Nom de l'application",
  'cui-application-tos': 'Consulter les conditions générales de vente',
  'cui-application-tos-agreement': "Accord Conditions Générales d'Utilisation",
  'cui-package-tos': "Vous ne l'avez pas des termes acceptés pour les paquets sélectionnés.",
  'cui-view-tos': "Voir les Conditions Générales d'Utilisation",
  'password-mismatch': 'les mots de passe doivent correspondre',
  'cui-back-to-review': 'Retour au commentaire',
  'email-mismatch': 'Les e-mails doivent correspondre',
  'no-applications-selected': "Vous n'avez pas des applications sélectionnées. Cliquez ici pour revenir à la sélection d'applications.",
  'cui-all-fields-required': 'Tous les champs sont requis',
  'cui-complete-registration': 'Complétez votre inscription ci-dessous avec',
  'cui-registered': 'Inscrit',
  'cui-open': 'Ouvrir',
  'cui-close': 'Fermer',
  'cui-street-address': 'Adresse de rue',
  'cui-zip': 'Zip *: français',
  'cui-language': 'La langue',
  'cui-phone-main': 'Principale',
  'cui-phone-office': 'Bureau',
  'cui-phone-fax': 'Téléphone / Fax',
  'cui-phone-mobile': 'Mobile',
  'cui-save': 'sauvegarder',
  'cui-cancel': 'Annuler',
  'cui-edit': 'modifier',
  'cui-phone': 'Téléphone',
  'search-by-app-name': "Recherche par nom d'application",
  'new-request': 'Nouvelle requête',
  'select-applications': 'Sélectionnez Applications',
  'browse-applications': 'Applications Parcourir',
  'go': 'Aller',
  'filter-list': 'Liste des filtres',
  'filter': 'Filtre',
  'owning-org': 'Org posséder',
  'my-applications': 'mes applications',
  'app-summary': 'App Résumé',
  'granted': 'Accordé',
  'bundled-applications': 'Applications groupées',
  'application-details': 'Détails de la demande',
  'my-claims': 'Mes réclamations',
  'related-applications': 'Applications liées',
  'review-request': "Demande d'examen",
  'back-to-search': 'Retour à la recherche',
  'requested-items': 'Articles demandés',
  'request-reason': 'demande Raison',
  'reason-im-requesting': 'Raison pour laquelle je me demande',
  'you-must-enter-a-reason': 'Vous devez entrer une raison de demander cette application',
  'cui-org-no-applications': "On dirait que votre organisation n'a pas de demandes. Vous pouvez toujours essayer à nouveau après la connexion.",
  'cui-filter-org-name': "Filtrer par nom d'organisation",
  'cui-address-example': 'Apt, bureau, Bldg. (optionnel)',
  'cui-filter-app-name': "Filtrer par nom de l'application",
  'cui-search-user-name': 'les utilisateurs de Recherche par nom',
  'page': 'Page',
  'cui-num-results-page': 'résultats par page',
  'submit-request': 'Envoyer la demande',
  'categories': 'Catégories',
  'cui-answer': 'Répondre',
  'cui-enter-password': 'Entrer le mot de passe',
  'cui-enter-new-password': 'Entrez un nouveau mot de passe',
  'cui-re-enter-new-password': 'ré-entrez le nouveau mot de passe',
  'granted-to-my-org': 'Accordée à mon organisation',
  'collected-items-for-request': 'Articles recueillis pour la demande',
  'cui-invalid-password': 'Mot de passe incorrect. Veuillez réessayer.',
  'cui-faq': 'FAQ',
  'cui-frequently-asked-questions': 'Questions fréquemment posées',
  'cui-admin-tools': "Outils d'administration",
  'cui-this-field-is-required': 'Ce champ est requis.',
  'cui-this-field-needs-to-be-longer': 'Ce champ doit être plus.',
  'cui-you-need-to-agree-to-toc': "Vous devez accepter les conditions d'utilisation avant de continuer.",
  'cui-this-is-not-valid-email': "Ce n'est pas un e-mail valide.",
  'cui-my-app-requests': "Mes demandes d'application",
  'cui-no-claims': 'Vous avez aucune réclamation pour cette application.',
  'cui-no-details': 'Aucun détail disponible.',
  'request': 'Demande',
  'all': 'Tout',
  'no-selected-apps': "Vous n'avez sélectionné toutes les applications.",
  'basic-info': 'Informations de base',
  'cui-error-username-exists': "ID d'utilisateur existe déjà! S'il vous plaît choisir un autre.",
  'password-reset': 'Réinitialiser le mot de passe',
  'current-password': 'Mot de passe actuel',
  'timezone-and-language': 'Fuseau horaire et langage',
  'challenge-questions': 'Questions défi',
  'security-question-repeated': 'Cette réponse a déjà été utilisé.',
  'cui-by-date-added': 'date ajoutée',
  'cui-alphabetically': 'Alphabétique',
  'active': 'actif',
  'pending': 'en attendant',
  'suspended': 'Suspendu',
  'title': 'Titre',
  'id': 'ID',
  'url': 'Url',
  'privacy-terms': 'Confidentialité et modalités',
  'help': 'Aidez-moi',
  'cui-learn-more-start': 'Apprendre encore plus',
  'cui-learn-more-end': 'pourquoi nous demandons ces informations',
  'cui-org-hierarchy': 'organisation Hiérarchie',
  'directory': 'Annuaire',
  'userID': "Identifiant d'utilisateur",
  'status': 'Statut',
  'locked': 'Verrouillé',
  'rejected': 'Rejeté',
  'removed': 'Suppression',
  'sort': 'Trier',
  'refine': 'Affiner',
  'or': 'Ou',
  'organizations': 'organisations',
  'roles': 'Les rôles',
  'organization-applications': 'Applications Organisation',
  'unactivated': 'inactivés',
  'log-out': 'Connectez - Out',
  'welcome': 'Bienvenue',
  'privacy': 'Intimité',
  'terms': 'termes',
  'user': 'Utilisateur',
  'top-level-orgs': 'Niveau supérieur Organisations',
  'invite-user': "Inviter l'utilisateur",
  'invite-division': 'Inviter Division',
  'username': "Nom d'utilisateur",
  'move': 'bouge toi',
  'no-bundled-or-related': 'Non fourni ou des applications connexes.',
  'cui-continue': 'Continuer',
  'cui-no-org-divisions': "Aucun divisions d'organisation",
  'inactive': 'Inactif',
  'deny': 'Nier',
  'approve': 'Approuver',
  'pending-request': 'Demande en attente',
  'review-approvals': 'examen des approbations',
  'cui-package-no-claims': 'Ce paquet contient aucune réclamation',
  'claims': 'Réclamations',
  'package-name': 'Nom du paquet',
  'submit-approvals': 'soumettre approbations',
  'view-details': 'Voir les détails',
  'request-date': 'Date de la demande',
  'registration-decision': "Décision d'homologation",
  'requested': 'demandé',
  'getting-user-info': 'Obtenir vos informations utilisateur ...',
  'approvals-submitted': 'approbations Submitted',
  'rejection-submitted': 'rejet Soumis',
  'approval-summary': 'approbation Résumé',
  'approved-items': 'Articles approuvés',
  'rejected-items': 'Articles rejetés',
  'registration-request-approved': "demande d'inscription approuvée",
  'registration-request-rejected': "Rejeté demande d'enregistrement",
  'no-items-rejected': 'Aucun élément rejeté',
  'no-items-approved': 'Aucun élément approuvé',
  'registration-request': "Demande d'enregistrement",
  'custom-api-loading': "L'application ... Initialisation",
  'new-grant': 'App Grant',
  'search-by-package-name': 'Recherche par nom de package',
  'search': 'Chercher',
  'administartor-?': 'Administrateur?',
  'submit-grant-update': 'Soumettre la mise à jour de subvention',
  'review-user-pending-approval': "Examen En attente d'approbation de l'utilisateur",
  'view-request-for': 'Voir demande de',
  'job-title': 'Profession',
  'query': 'Question',
  'suspend-app': 'suspendre App',
  'new-grants': 'nouvelles subventions',
  'update-grant-settings': 'Mise à jour des paramètres de subvention',
  'assign-new-grant-to': 'Assigner nouvelle subvention à',
  'division': 'Division',
  'redirecting-to-sso': "Demander vos informations d'identification",
  'included-applications': 'Applications incluses',
  'selected-sub-packages': 'Certaines sous-packages',
  'specify-password': 'Spécifiez le mot de passe',
  'suspend': 'Suspendre',
  'reset-password': 'réinitialiser le mot de passe',
  'confirm-password-reset': 'Etes-vous sûr de vouloir réinitialiser le mot de passe pour cet utilisateur?',
  'yes': 'Oui',
  'within': 'dans',
  'search-within': 'Rechercher dans les',
  'in-your-org': 'dans votre org',
  'people': 'Gens',
  'revoke-package': 'révoquer paquet',
  'cui-by-username': "Nom d'utilisateur",
  'cui-by-status': 'Statut',
  'cool-got-it': 'Cool, got it',
  'organization-directory': 'organisation Répertoire',
  'org-nav-invite-links': "Organisation Navigation et liens d'invitation",
  'org-dir-filters': 'Organisation Filtres Directory',
  'org-dir-list': 'Organisation Liste Répertoire',
  'apps': 'applications',
  'apps-upper': 'APPLICATIONS',
  'history-upper': 'HISTOIRE',
  'profile-upper': 'PROFIL',
  'roles-upper': 'LES RÔLES',
  'your-app-request-in-review': 'Votre demande de demande a été soumise',
  'error-generic': 'Il y avait un problème chargement des données sur cette page. Veuillez réessayer.',
  'cui-application-administrator': "n'a pas le rôle d'administrateur de l'application, qui doit être attribué avant qu'un utilisateur puisse accorder des droits d'administration pour une application donnée. Ceci est un réglage de l'heure.",
  'cui-assign-confirm': 'Voulez-vous attribuer ce rôle maintenant?',
  'cui-suspend-warning': 'ne pourra pas accéder à cette application',
  'cui-suspend-confirm': 'Etes-vous sûr que vous voulez suspendre la séance?',
  'cui-notify-user': "avertir l'utilisateur",
  'cui-users': 'Utilisateurs',
  'cui-no': 'Non',
  'cui-remove': 'Suppression',
  'cui-org-abbrev': 'org',
  'cui-userProfile-user-error': 'Il y avait une erreur de récupération des données utilisateur. Veuillez réessayer.',
  'cui-userProfile-security-error': 'Il y avait une erreur de récupération des données de question de sécurité. Veuillez réessayer.',
  'cui-userProfile-password-error': 'Il y avait une erreur récupération de données de politique de mot de passe. Veuillez réessayer.',
  'cui-suspend-success': "Cette application est maintenant suspendu à l'utilisateur sélectionné",
  'cui-unlock': 'Ouvrir',
  'cui-unlock-password-confirm': 'Etes-vous sûr que vous souhaitez déverrouiller le mot de passe de cet utilisateur?',
  'cui-error-unlocking-password': "Désolé, une erreur déverrouiller le mot de passe de l'utilisateur.",
  'cui-error-person-request': "Impossible de récupérer les données de demande d'enregistrement pour cet utilisateur.",
  'cui-error-email-exists': 'Adresse e-mail a déjà été prise',
  'cui-password-history-rule': 'ne correspond à aucun de vos mots de passe précédents {{}} de numberOfPasswords',
  'cui-password-policy': 'Politique de mot de passe',
  'cui-security-admin': 'Administrateurs de sécurité',
  'cui-button-loading-text': 'Chargement...',
  'cui-username-taken': "Le nom d'utilisateur est pris",
  'cui-no-applications': 'Vous avez actuellement aucune application',
  'cui-mask-answers': 'Masque / Démasquer réponses de sécurité',
  'cui-pwd-reset-success': 'Password Reset succès!',
  'cui-last-login': 'Dernière connexion',
  'cui-need-different-app': "Besoin d'une autre application",
  'cui-go-back-to': 'Revenir à',
  'cui-tos-applications': "S'il vous plaît accepter les conditions d'utilisation pour les applications sélectionnées",
  'cui-selected-apps': 'Applications sélectionnées',
  'cui-authentication-policy': "Politique d'authentification",
  'cui-selected': 'Choisi',
  'cui-tac': 'Termes et conditions',
  'cui-accept': 'Acceptez',
  'cui-tac-agree': 'Vous devez accepter les Termes et Conditions à continuer.',
  'cui-printer-friendly-tac': "Conditions Générales d'Utilisation imprimable",
  'cui-my-history': 'Mon histoire',
  'cui-status-history': 'Histoire Mon statut',
  'cui-app-history': 'Historique de la candidature',
  'cui-password-change-log': 'changement de mot de passe journal',
  'cui-date': 'Rendez-vous amoureux',
  'cui-event-type': "Type d'événement",
  'cui-action-by': 'Joué par action',
  'cui-notes': 'Remarques',
  'cui-try-again': 'Veuillez réessayer.',
  'cui-password-change-log-error': 'Il y avait une erreur de récupération journal de changement de mot de passe.',
  'cui-userstatus-history-error': "Il y avait une erreur de récupération historique du statut de l'utilisateur.",
  'cui-claims-error': 'Il y avait une erreur de récupération des revendications.',
  'cui-org-app-suspend-success': 'Cette application est suspendue à partir des organisations sélectionnées, tous les utilisateurs et tous les sous-organisations.',
  'cui-org-app-suspend-msg1': "Cette action suspend l'action de tous les utilisateurs et les organisations sous-même en utilisation active.",
  'cui-org-app-suspend-msg2': 'Êtes-vous sûr de vouloir suspendre',
  'cui-from': 'de',
  'cui-application-granted-history': "Histoire d'application Grant",
  'cui-application-requested-history': "Demande d'application Histoire",
  'approved': 'Approuvé',
  'decision': 'Décision',
  'evaluator': 'évaluateur',
  'action': 'action',
  'cui-invalid-invitation': 'Invitation est soit déjà utilisé ou non valide',
  'cui-by-request-date': 'Date de la demande',
  'cui-by-decision-date': 'Date de décision',
  'cui-no-orgs-for-name': "Aucune organisation n'a été trouvée pour le nom spécifié. S'il vous plaît essayer avec un autre nom.",
  'requests': 'demandes',
  'no-pending-apps': "Vous avez aucune demande d'application en attente.",
  'description': 'La description',
  'launch': 'lancement',
  'manage-applications': 'Gérer des applications',
  'request-type': 'type de demande',
  'phase': 'Phase',
  'date-submitted': 'Date de soumission',
  'cui-pending-requests-error': 'Il y avait une erreur dans la récupération / demandes de mise à jour.',
  'no-requests-by-name': "Aucune demande n'a été trouvée pour le nom spécifié. S'il vous plaît essayer avec un autre nom.",
  'cannot-change-password': 'Impossible de changer le mot de passe maintenant',
  'select-claims': 'Sélectionnez les revendications',
  'grant-reason': 'Raison Grant',
  'grants-assigned': 'Nouvelles subventions Assigned',
  'suspend-error': 'Il y avait une erreur de suspendre les demandes.',
  'unsuspend-error': 'Il y avait une erreur dans les demandes Réactiver.',
  'approval': 'Approbation',
  'administrator': 'Administrateur',
  'submitted': 'soumis',
  'no-bundled': 'Aucune application empaquetés',
  'disallowed-password-rule': 'Ne peut pas contenir un mot sur la liste des mots refusés',
  'request-approve-or-rejected': 'Cette demande est soit approuvé / Rejeté',
  'application': 'Application',
  'show-all': 'Montre tout',
  'cui-subject': 'Assujettir',
  'cui-es': '(S)',
  'cui-invite-user': 'Inviter un utilisateur dans',
  'cui-invite-user-success': "votre demande d'invitation envoyé utilisateur",
  'cui-email-recipt': 'Entrez email du destinataire (multiple séparé par des virgules)',
  'cui-invite-verbiage': 'Inviter pour une des options suivantes',
  'select': 'Sélectionner',
  'change-org': 'changement Org',
  'cui-invite-user-sub': "Inscrivez-vous en tant qu'utilisateur pour rejoindre",
  'cui-invite-user-select': 'Rechercher un org',
  'cui-send-invitation': 'Envoyer une invitation',
  'invite': 'Inviter',
  'cui-invite-tlo-success': "Votre organisation de haut niveau demande d'invitation envoyée",
  'cui-invite-tlo': 'Inviter une nouvelle organisation',
  'cui-invite-division-success': "Votre demande d'invitation de l'entreprise envoyée",
  'cui-invite-division': 'Inviter une organisation',
  'cui-tlo-sub': 'Inscrivez-vous en tant que nouvelle organisation',
  'cui-division-sub': 'Inscrivez-vous comme adminstrateur dans les',
  'search-by-org-name': "Recherche par nom d'organisation",
  'app-approval-error': "Il y avait une erreur dans l'approbation des demandes App.",
  'modify-claims': 'modifier revendications',
  'unsuspend-app': 'Réactiver App',
  'remove-app': "Supprimer l'application",
  'user-details': "Détails de l'utilisateur",
  'reason': 'Raison',
  'required': 'Champs obligatoires',
  'cui-unsuspend-confirm': 'Etes-vous sûr que vous voulez maintenant lever la suspension?',
  'unsuspend': 'Réactiver',
  'remove-confirm': 'Etes-vous sûr que vous souhaitez supprimer maintenant?',
  'remove': 'Retirer',
  'my-organization': 'mon organisation',
  'request-app': 'demande App',
  'no-apps-found': 'Aucune application trouvée.',
  'refine-search': "S'il vous plaît affiner vos critères de recherche.",
  'your-assign-role-success': 'Nouveau rôle assigné',
  'cui-assigned-roles': 'Rôles Assigned',
  'cui-available-roles': 'Rôles disponibles',
  'cui-browse-by-category': 'Parcourir par catégorie',
  'cui-back-navigation-requests': 'Retour navigation et demandes',
  'cui-search-results': 'Résultats de la recherche',
  'cui-new-grant-search-results': 'Nouvelle subvention Résultats de la recherche',
  'cui-username-close': "Nom d'utilisateur et la navigation à proximité",
  'cui-user-no-apps': "L'utilisateur n'a aucune application",
  'cui-no-roles-assigned': "Cet utilisateur n'a pas les rôles assignés.",
  'status-history': 'Historique du statut',
  'cui-no-status-history': "Cet utilisateur n'a pas d'antécédents d'état.",
  'cui-pwd-reset-msg1': 'Password Reset est réussie. Nouveau mot de passe est:',
  'cui-pwd-reset-msg2': 'Remarque: si vous voyez que la première moitié du mot de passe, puis second mot de passe la moitié sera envoyée aux utilisateurs enregistrés email.',
  'users-upper': 'UTILISATEURS',
  'hierarchy-upper': 'HIÉRARCHIE',
  'privileges': 'privilèges',
  'expand-all': 'Développer tout',
  'collapse-all': 'Réduire tout',
  'no-records': 'Aucun enregistrement trouvé.',
  'contact-us': 'Contactez nous',
  'cui-error-organization-request': "Impossible de récupérer les données de demande d'enregistrement pour cette organisation.",
  'cui-error-organization-app-request': "Impossible de récupérer les données de demande d'application pour cette organisation",
  'cui-error-user-app-request': "Impossible de récupérer les données de demande d'application pour cet utilisateur",
  'assign': 'Attribuer',
  'search-by-person-name': 'Recherche par nom de personne',
  'grant-history': 'Histoire Grant',
  'request-history': 'demande Histoire',
  'social-login': 'Connexion sociale',
  'facebook': 'Facebook',
  'twitter': 'Gazouillement',
  'link': 'Lien',
  'unlink': 'séparer',
  'invalid-url': "Ce n'est pas une URL valide.",
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'Administration',
  'services': 'Prestations de service',
  'n-phase': 'N - Approbation de phase',
  'edit-package': 'Modifier un paquetage',
  'is-requestable': 'est-Demandable',
  'is-displayable': 'est-ce affichable',
  'is-grantable': 'grantable est',
  'require': 'Exiger',
  'is-requestable-desc': "Indiquez si l'utilisateur peut demander cette application.",
  'is-grantable-desc': "Indiquez si cette demande peut être accordée directement par l'administration de l'entreprise à l'utilisateur",
  'is-displayable-desc': "Indiquez si l'icône de package doit être affiché sur ma page Applications",
  'require-reason-desc': "Indiquez si ce paquet nécessaire à l'utilisateur de fournir une raison pour demander ce forfait",
  'company-admin': 'société Administrateur',
  'application-admin': "Administrateur d'application",
  'company-admin-desc': "Ceci est la phase d'approbation par défaut, il devrait être Oui s'il n'y a pas d'autre phase nécessaire",
  'application-admin-desc': "La demande application utilisateur doit être approuvé par l'administrateur de l'application?",
  'add-admins': 'Ajouter administrateurs',
  'cardinality-indicator': 'Indicateur cardinalité',
  'cui-one': 'Un',
  'cui-many': 'Beaucoup',
  'claim-values': 'Valeurs de réclamation',
  'cui-add': 'Ajouter',
  'cui-view': 'Vue',
  'cui-claim': 'Prétendre',
  'cui-category': 'Catégorie',
  'cui-service': 'Un service',
  'cui-delete': 'Effacer',
  'federation-conn': 'Connexion Fédération',
  'updated-date': 'Mis à jour',
  'target-url': 'Cible URL',
  'remote-app-id': 'Id application à distance',
  'mobile-sso-url': 'URL mobile SSO',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'Paquet',
  'cui-create': 'Créer',
  'more-languages': 'plus de langues',
  'duplicate-language-error': 'langues en double ne sont pas autorisés',
  'cui-nextstep': 'Prochain',
  'create-package': 'Créer un package',
  'manage-package-claims': 'Gérer les revendications Emballage',
  'cardinality-indicator-error': 'Cardinalité indicateur ne peut pas être un',
  'value-id-exists': "L'ID de valeur existe déjà",
  'claim-id-exists': 'Id revendication existe déjà',
  'cui-new': 'Nouveau',
  'package-success-content': 'Package créé avec succès',
  'add-claims': 'Ajouter des revendications',
  'package-update-success': 'Package mis à jour avec succès'
}
export {
  fr
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/fr.js